//IMPORTAÇÃO DAS BIBLIOTECAS---------------------------------------------------
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';



//IMPORTAÇÃO DOS COMPONENTES---------------------------------------------------
import styles from './userMessages.module.css';
import { GoArrowLeft, GoX, GoCheck } from "react-icons/go";
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import { useAppContext } from "../../../../AppContext.js";



const UserMessages = ({ messages, open, onClose, marcarComoLida, errorLoadMsg }) => {
  // Estado local para controlar mensagens, sincronizado com as props.
  const [localMessages, setLocalMessages] = useState(messages);
  // estado para mostrar mensagem de erro de requisição
  const [error, setError] = useState(errorLoadMsg);
  // Hook de tradução
  const { t } = useTranslation();

  // Hook para verificar se está em modo app
  const { isApp } = useAppContext();

  // Sincroniza o estado local quando as mensagens externas mudam.
  useEffect(() => {
    setLocalMessages(messages);
  }, [messages]);

  // Sincroniza o estado local quando erro na requisição
  useEffect(() => {
    if (errorLoadMsg) {
      setError(true);
    } else {
      setError(false);
    }
  }, [errorLoadMsg]);

  // Gerencia efeitos colaterais do modal (scroll lock, fechar com ESC).
  useEffect(() => {
    if (!open) {
      document.body.style.overflow = "";
      return;
    }
    document.body.style.overflow = "hidden";
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);

    // Função de limpeza
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleEsc);
    };
  }, [open, onClose]);

  //modal fechado ao iniciar
  if (!open) return null;



  // html do componente
  return (
    <div className={styles.overlay}>
      <div className={styles.modal} role="dialog" aria-modal="true" aria-label={t("messages")}>
        <div className={`${styles.headerMessages} ${isApp ? styles.headerMessagesApp : styles.headerMessagesWeb}`}>
          <GoArrowLeft className={styles.arrowClose} onClick={onClose} title={t("Close")} />
          <GoX className={styles.xClose} onClick={onClose} title={t("Close")} />
          <h2>{t("Messages")}</h2>
        </div>
        {localMessages && localMessages.length > 0 ? (
          <ul className={styles.listMessages}>
            {localMessages.map(msg => (
              <li
                className={`${styles.userMsg} ${msg.read === false ? styles.unreadMsg : ''}`}
                key={msg._id}
                onClick={() => marcarComoLida(msg)}
              >
                <div>
                  <span>{msg.content}</span>
                  <Link className={styles.linkMsg} to={msg.link}>{" " + msg.nameLink}</Link>
                </div>
                <div className={styles.msgInfoRight}>
                  <span className={styles.msgDate}>
                    {msg.dateString ? msg.dateString : ''}
                  </span>
                  {!msg.read ? (
                    <GoCheck
                      className={styles.noReadIcon}
                      title={t("Mark as read")}
                    />
                  ) : (
                    <IoCheckmarkDoneOutline
                      className={styles.ReadIcon}
                      title={t("Message read")}
                    />
                  )}
                </div>
              </li>
            ))}
          </ul>
        ) : error ? (
          <p className={styles.emptyUserMsgError}>{t("Error loading messages. Try again later!")}</p>
        ) : (
          <p className={styles.emptyUserMsg}>{t("You don't have any messages.")}</p>
        )}
      </div>
    </div>
  );
};

export default UserMessages;